import React from "react"
import { RecoilRoot } from "recoil"
import { FirebaseProvider } from "../services"

export default ({ element }) => (
    <FirebaseProvider>
        <RecoilRoot>{element}</RecoilRoot>
    </FirebaseProvider>
)
